import Config from "@/vuex/Config";
import Engraving from "@/vuex/Engraving";
import CatchFetch from "@/assets/Cache/Fetch";
import Logger from "@/assets/Helper/Logger";

let DAOEngraving = function () {

    this.get = function () {
        CatchFetch.cacheFirst(Config.getters.getApiHostWithLocalStr + '/v2/engraving/')
            .then(json => {
                Engraving.dispatch("setData", json.result).catch((error) => {
                    Logger.error(error);
                });
            })
            .catch((error) => {
                Logger.error(error);
            });
    }
};

export default new DAOEngraving();